import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import i18next from 'i18next'
import GridContainer from './GridContainer'
import Wopi360TargetForm from './Wopi360TargetForm'

import adminStyles from './styles/admin.scss'

export default class Wopi360TargetEdit extends Component {
  handleSave = (
    givenName,
    familyName,
    email,
    organisation,
    role,
    deadlineAt,
    language,
    unitUuids
  ) => {
    this.props.onEdit(
      this.props.currentOrganisationId,
      this.props.wopi360Target.uuid,
      givenName,
      familyName,
      email,
      organisation,
      role,
      deadlineAt,
      language,
      unitUuids
    )
  }

  render() {
    const { wopi360Target, units, currentLanguage } = this.props

    return (
      <GridContainer>
        <div className={adminStyles.app}>
          <Row>
            <Col md={12}>
              <header>
                <h1>{i18next.t('edit_wopi360_target')}</h1>
              </header>

              <Wopi360TargetForm
                target={wopi360Target}
                unitSuggestions={units ? units.toArray() : []}
                currentLanguage={currentLanguage}
                onSave={this.handleSave}
                saveText={i18next.t('save')}
                cancelTo={`/target/${wopi360Target.uuid}/details`}
                hideUnits
              />
            </Col>
          </Row>
        </div>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360TargetEdit.js